/**
 * 登出弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import Modal from 'boron/ScaleModal';


const noop = function(){};

const style = {
    modalStyle: {
         width: '380px'
    },
    contentStyle: {
        width: '380px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(23,19,31, 0.7)"
    }
}

class OverlayPop  extends Component {
    static defaultProps = {
        onHide: noop,
        onConfirm: noop,
        onCancel: noop,
        title: '',
        content: '',
        type: 'confirm',
        cancelText: '',
        confirmText: '',
        confirm: '',
        closeOnClick: true
    }
    constructor(props){
        super(props);

        this.status = 'cancel';
    }

    componentDidMount() {
        this.showModal();
    }

    onConfirm() {
        this.hideModal();
        this.status = 'confirm';
    }
    onCancel() {
        this.hideModal();
        this.status = 'cancel';
    }

    onHide() {
        if (this.status == 'confirm') {
            this.props.onConfirm();
        } else {
            this.props.onCancel();
        }
        this.props.onHide();
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    render() {
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }

        return (
            <Modal 
                ref="modal" 
                closeOnClick={this.props.closeOnClick}
                modalStyle={modalStyle}  
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle}
                onHide={this.onHide.bind(this)}
            >
                <div className="overlay-pop">
                    <div className="overlay-pop-hd">{this.props.title || lang.template('提示')}</div>
                    <div className="overlay-pop-bd"  dangerouslySetInnerHTML={{__html: this.props.content }}></div>
                    <div className="overlay-pop-ft">
                        { this.props.type == 'confirm' ? <button className="btn cancel" onClick={()=>this.onCancel()}>{this.props.cancelText || lang.template('取消')}</button> : null}                        
                        <button className="btn confirm" onClick={()=>this.onConfirm()}>{this.props.confirmText || lang.template('确认')}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}


module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <OverlayPop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/lib/popup/confirm.js